<template>
  <div class="">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
          <el-form-item label="运单编号:" class="item1">
            <el-input  placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNos" ></el-input>
          </el-form-item>
          <el-form-item label="创建时间:" class="item2">
            <el-date-picker
              v-model="createTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="签收时间:" class="item2">
            <el-date-picker
              v-model="actualSignings"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结算状态:">
            <el-select v-model="searchFrom.yfSettlementStates" placeholder="请选择结算状态">
              <el-option v-for="item in yfSettlementList" :label="item.showName" :key="item.value"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="运单号:" prop="wayNo">
            <el-input v-model="searchFrom.wayNo" placeholder="请输入运单号"></el-input>
          </el-form-item> -->
          <el-form-item label="货物类型:">
            <el-select v-model="searchFrom.productTypeName" placeholder="请选择货物类型">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运单状态:">
            <el-select v-model="searchFrom.wayState" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option label="待配载" value="0" ></el-option>
              <el-option label="待装车" value="1" ></el-option>
              <el-option label="运输中" value="2" ></el-option>
              <el-option label="待签收" value="3" ></el-option>
              <el-option label="已签收" value="4" ></el-option>
              <el-option label="已作废" value="5" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签收人:" prop="actualSigningPerson">
            <el-input v-model="searchFrom.actualSigningPerson" placeholder="请输入签收人"></el-input>
          </el-form-item>
        </div>
        <div style="">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
            <el-button type="primary" size="mini" :disabled="isDisable" @click="daochuFN">导出</el-button>
          </el-form-item>
          <span>
            <el-form-item>
              <p class="margin0">运费总额合计：<span class="red">{{map.freightTaxTotalSum}}</span>元</p>
            </el-form-item>
          </span>
        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tabref"  class="tableComent" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
        <el-table-column prop="expenditurePatternName" label="支出方式" width="90" :formatter="formatterRowEmpty">
          <!-- <template scope="scope">
            <span v-show="scope.row.expenditurePattern == '0'">月结</span>
            <span v-show="scope.row.expenditurePattern == '1'">现结</span>
          </template> -->
        </el-table-column>
        <el-table-column property="" width="100" label="运单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.wayState==0">待配载</span>
            <span v-else-if="scope.row.wayState==1">待装车</span>
            <span style="color: #E99D42;" v-else-if="scope.row.wayState==2" >运输中</span>
            <span style="color: #D51212;" v-else-if="scope.row.wayState==3" >待签收</span>
            <span style="color: #81B337;" v-else-if="scope.row.wayState==4" >已签收</span>
            <span style="color: #9A9A9A;" v-else-if="scope.row.wayState==5" >已作废</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="结算状态" width="100">
          <template scope="scope">
            <span class="wsStyle" v-show="scope.row.yfSettlementStates == '-1'">未对账</span>
            <span class="wsStyle" v-show="scope.row.yfSettlementStates == '0'">未确认</span>
            <span class="ysStyle" v-show="scope.row.yfSettlementStates == '2'">已确认</span>
          </template>
        </el-table-column>
        <el-table-column prop="payer" label="收款部门" width="220" :show-overflow-tooltip="true" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" width="120">
        </el-table-column>
        <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="freightPricingTypeName" label="运费计价" width="100" :formatter="formatterRowEmpty">
          <!-- <template scope="scope">
            0.按吨、1.按车、2.按方、3.按件
            <span v-show="scope.row.freightPricingType == '0'">按吨</span>
            <span v-show="scope.row.freightPricingType == '1'">按车</span>
            <span v-show="scope.row.freightPricingType == '2'">按方</span>
            <span v-show="scope.row.freightPricingType == '3'">按件</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="" label="运费单价" width="120">
          <template scope="scope">
            <div>
              <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
              <span v-if="scope.row.freightPricingType == '1'">
                <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                <span v-else>-</span>
              </span>
              <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
              <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
              <span v-if="scope.row.freightPricingType == '' || scope.row.freightPricingType == null">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="freightAmount" label="运费金额(元)" width="130" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="disburseSurcharge" label="支出附加费(元)" width="140" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="freightRemark" label="支出备注" width="130" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="freightAmountTotal" label="运费总额(元)" width="120" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="generalCarrier" label="承运方" width="200" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" width="120" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="driverName" label="司机姓名" width="120" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="driverPhone" label="司机电话" width="120" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
        </el-table-column>
        <!-- <el-table-column prop="" label="账单号" width="200">
        </el-table-column> -->
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="180"></el-table-column>
        <el-table-column prop="actualSigningPerson" label="签收人" width="120" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import { findWayBusinessList, getDictionaryDetailList, findWayBusinessListTotal } from '@/api/newTMS'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'Freight',
  components: {
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      incomeList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '月结',
          value: '0'
        },
        {
          showName: '现结',
          value: '1'
        }
      ],
      yfSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未对账',
          value: '-1'
        },
        {
          showName: '未确认',
          value: '0'
        },
        {
          showName: '已确认',
          value: '2'
        }
      ],
      yfInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未开票',
          value: '0'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '已开票',
          value: '2'
        }
      ],
      HWlist: [],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTimes: [],
      actualSignings: [],
      searchFrom: {
        payerType: '0',
        yfSettlementStates: '-1',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: ''
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00M0100', '01N00M0200'],
      tableList: [],
      map: {
        freightTaxTotalSum: 0
      },
      isDisable: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/YFcalculate')
    this.createTimes = getLastMonth()
    this.getList()
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 210 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      if (this.createTimes) {
        this.$set(this.searchFrom, 'createTimeStart', this.createTimes[0])
        this.$set(this.searchFrom, 'createTimeEnd', this.createTimes[1])
      } else {
        this.$set(this.searchFrom, 'createTimeStart', '')
        this.$set(this.searchFrom, 'createTimeEnd', '')
      }
      if (this.actualSignings) {
        this.$set(this.searchFrom, 'actualSigningTimeStart', this.actualSignings[0])
        this.$set(this.searchFrom, 'actualSigningTimeEnd', this.actualSignings[1])
      } else {
        this.$set(this.searchFrom, 'actualSigningTimeStart', '')
        this.$set(this.searchFrom, 'actualSigningTimeEnd', '')
      }
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
      } else {
        this.searchFrom.wayNos = ''
        this.searchFrom.wayNoList = null
      }
      findWayBusinessList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      findWayBusinessListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        payerType: '0',
        yfSettlementStates: '-1',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: '',
        wayNoList: null
      }
      // this.createTimes = []
      this.createTimes = getLastMonth()
      this.actualSignings = []
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 导出
    daochuFN () {
      if (this.createTimes) {
        this.$set(this.searchFrom, 'createTimeStart', this.createTimes[0])
        this.$set(this.searchFrom, 'createTimeEnd', this.createTimes[1])
      } else {
        this.$set(this.searchFrom, 'createTimeStart', '')
        this.$set(this.searchFrom, 'createTimeEnd', '')
      }
      if (this.actualSignings) {
        this.$set(this.searchFrom, 'actualSigningTimeStart', this.actualSignings[0])
        this.$set(this.searchFrom, 'actualSigningTimeEnd', this.actualSignings[1])
      } else {
        this.$set(this.searchFrom, 'actualSigningTimeStart', '')
        this.$set(this.searchFrom, 'actualSigningTimeEnd', '')
      }
      delete this.searchFrom.pageNo
      delete this.searchFrom.pageSize
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
      } else {
        this.searchFrom.wayNos = ''
        this.searchFrom.wayNoList = null
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportInsideYfWayList',
        this.searchFrom,
        '应付明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
.box{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill,270px);
  grid-auto-flow: row dense;
  .item1{
    grid-row-start: span 2;
  }
  .item2{
    grid-column-start: span 2;
    width: 540px;
  }
}
</style>
